function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.4001 6.55798H8.01011V9.62198H12.2641C11.8671 11.569 10.2091 12.686 8.01011 12.686C7.3944 12.6872 6.78452 12.5668 6.21545 12.3317C5.64639 12.0966 5.12934 11.7515 4.69396 11.3161C4.25859 10.8808 3.91347 10.3637 3.6784 9.79464C3.44332 9.22557 3.32293 8.61569 3.32411 7.99998C3.32293 7.38427 3.44332 6.77439 3.6784 6.20532C3.91347 5.63626 4.25859 5.1192 4.69396 4.68383C5.12934 4.24846 5.64639 3.90334 6.21545 3.66826C6.78452 3.43319 7.3944 3.31279 8.01011 3.31398C9.12811 3.31398 10.1371 3.71098 10.9301 4.35998L13.2371 2.05298C11.8311 0.82698 10.0291 0.0699798 8.01011 0.0699798C6.96788 0.0669437 5.93533 0.269987 4.97184 0.667431C4.00836 1.06488 3.13296 1.64888 2.39598 2.38585C1.65901 3.12283 1.07501 3.99823 0.677563 4.96171C0.280119 5.92519 0.0770756 6.95775 0.0801117 7.99998C0.0770756 9.04221 0.280119 10.0748 0.677563 11.0382C1.07501 12.0017 1.65901 12.8771 2.39598 13.6141C3.13296 14.3511 4.00836 14.9351 4.97184 15.3325C5.93533 15.73 6.96788 15.933 8.01011 15.93C11.9751 15.93 15.5801 13.047 15.5801 7.99998C15.5801 7.53198 15.5081 7.02698 15.4001 6.55798Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-0.640137 12.686V3.31396L5.48586 7.99996L-0.640137 12.686Z",
  fill: "#FBBC05"
}));

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.4001 6.55798H8.01011V9.62198H12.2641C11.8671 11.569 10.2091 12.686 8.01011 12.686C7.3944 12.6872 6.78452 12.5668 6.21545 12.3317C5.64639 12.0966 5.12934 11.7515 4.69396 11.3161C4.25859 10.8808 3.91347 10.3637 3.6784 9.79464C3.44332 9.22557 3.32293 8.61569 3.32411 7.99998C3.32293 7.38427 3.44332 6.77439 3.6784 6.20532C3.91347 5.63626 4.25859 5.1192 4.69396 4.68383C5.12934 4.24846 5.64639 3.90334 6.21545 3.66826C6.78452 3.43319 7.3944 3.31279 8.01011 3.31398C9.12811 3.31398 10.1371 3.71098 10.9301 4.35998L13.2371 2.05298C11.8311 0.82698 10.0291 0.0699798 8.01011 0.0699798C6.96788 0.0669437 5.93533 0.269987 4.97184 0.667431C4.00836 1.06488 3.13296 1.64888 2.39598 2.38585C1.65901 3.12283 1.07501 3.99823 0.677563 4.96171C0.280119 5.92519 0.0770756 6.95775 0.0801117 7.99998C0.0770756 9.04221 0.280119 10.0748 0.677563 11.0382C1.07501 12.0017 1.65901 12.8771 2.39598 13.6141C3.13296 14.3511 4.00836 14.9351 4.97184 15.3325C5.93533 15.73 6.96788 15.933 8.01011 15.93C11.9751 15.93 15.5801 13.047 15.5801 7.99998C15.5801 7.53198 15.5081 7.02698 15.4001 6.55798Z",
  fill: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-0.640137 3.314L5.48586 8L8.00986 5.801L16.6609 4.396V-0.651001H-0.640137V3.314Z",
  fill: "#EA4335"
}));

var _ref6 = /*#__PURE__*/React.createElement("mask", {
  id: "mask2",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.4001 6.55798H8.01011V9.62198H12.2641C11.8671 11.569 10.2091 12.686 8.01011 12.686C7.3944 12.6872 6.78452 12.5668 6.21545 12.3317C5.64639 12.0966 5.12934 11.7515 4.69396 11.3161C4.25859 10.8808 3.91347 10.3637 3.6784 9.79464C3.44332 9.22557 3.32293 8.61569 3.32411 7.99998C3.32293 7.38427 3.44332 6.77439 3.6784 6.20532C3.91347 5.63626 4.25859 5.1192 4.69396 4.68383C5.12934 4.24846 5.64639 3.90334 6.21545 3.66826C6.78452 3.43319 7.3944 3.31279 8.01011 3.31398C9.12811 3.31398 10.1371 3.71098 10.9301 4.35998L13.2371 2.05298C11.8311 0.82698 10.0291 0.0699798 8.01011 0.0699798C6.96788 0.0669437 5.93533 0.269987 4.97184 0.667431C4.00836 1.06488 3.13296 1.64888 2.39598 2.38585C1.65901 3.12283 1.07501 3.99823 0.677563 4.96171C0.280119 5.92519 0.0770756 6.95775 0.0801117 7.99998C0.0770756 9.04221 0.280119 10.0748 0.677563 11.0382C1.07501 12.0017 1.65901 12.8771 2.39598 13.6141C3.13296 14.3511 4.00836 14.9351 4.97184 15.3325C5.93533 15.73 6.96788 15.933 8.01011 15.93C11.9751 15.93 15.5801 13.047 15.5801 7.99998C15.5801 7.53198 15.5081 7.02698 15.4001 6.55798Z",
  fill: "white"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-0.640137 12.686L10.1729 4.396L13.0209 4.756L16.6609 -0.651001V16.651H-0.640137V12.686Z",
  fill: "#34A853"
}));

var _ref8 = /*#__PURE__*/React.createElement("mask", {
  id: "mask3",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.4001 6.55798H8.01011V9.62198H12.2641C11.8671 11.569 10.2091 12.686 8.01011 12.686C7.3944 12.6872 6.78452 12.5668 6.21545 12.3317C5.64639 12.0966 5.12934 11.7515 4.69396 11.3161C4.25859 10.8808 3.91347 10.3637 3.6784 9.79464C3.44332 9.22557 3.32293 8.61569 3.32411 7.99998C3.32293 7.38427 3.44332 6.77439 3.6784 6.20532C3.91347 5.63626 4.25859 5.1192 4.69396 4.68383C5.12934 4.24846 5.64639 3.90334 6.21545 3.66826C6.78452 3.43319 7.3944 3.31279 8.01011 3.31398C9.12811 3.31398 10.1371 3.71098 10.9301 4.35998L13.2371 2.05298C11.8311 0.82698 10.0291 0.0699798 8.01011 0.0699798C6.96788 0.0669437 5.93533 0.269987 4.97184 0.667431C4.00836 1.06488 3.13296 1.64888 2.39598 2.38585C1.65901 3.12283 1.07501 3.99823 0.677563 4.96171C0.280119 5.92519 0.0770756 6.95775 0.0801117 7.99998C0.0770756 9.04221 0.280119 10.0748 0.677563 11.0382C1.07501 12.0017 1.65901 12.8771 2.39598 13.6141C3.13296 14.3511 4.00836 14.9351 4.97184 15.3325C5.93533 15.73 6.96788 15.933 8.01011 15.93C11.9751 15.93 15.5801 13.047 15.5801 7.99998C15.5801 7.53198 15.5081 7.02698 15.4001 6.55798Z",
  fill: "white"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.6609 16.651L5.48692 8.00099L4.04492 6.91799L16.6609 3.31299V16.651Z",
  fill: "#4285F4"
}));

var SvgGoogleIcon = function SvgGoogleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GoogleIcon.cb587962.svg";
export { ForwardRef as ReactComponent };